import { useEffect, useState } from "react";
import { checkSpeedMerchantStatus } from "services/ordersApi";

/** ตรวจว่าโรงงานมีจุดรับสินค้า (Speed merchant) ก่อนเข้าเมนูส่งพัสดุ */
export function useParcelMerchantGate() {
  const [hasMerchant, setHasMerchant] = useState<boolean | null>(null);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await checkSpeedMerchantStatus();
        setHasMerchant(res.status === "success" && !!res.data?.has_speed_merchant);
      } catch {
        setHasMerchant(false);
      }
    };
    check();
  }, []);

  return { hasMerchant, loading: hasMerchant === null };
}
